import { createFileRoute, Outlet } from "@tanstack/react-router"

/**
 * `/cni/firms/*` parent layout — sadece Outlet. List `_authed.cni.firms.index.tsx`,
 * detail `_authed.cni.firms.$id.tsx` child'ları olarak render olur.
 */
export const Route = createFileRoute("/_authed/cni/firms")({
  component: CniFirmsLayout,
})

function CniFirmsLayout() {
  return <Outlet />
}
